<script generic="T extends ArrayOrNested<SelectItem>" lang="ts" setup>
  import type { ArrayOrNested, GetItemValue, NestedItem, SelectItem, SelectProps } from '@nuxt/ui';

  const props = defineProps<{
    items: SelectProps<T>['items'];
    labelKey?: string;
    valueKey?: string;
  }>();

  const modelValue = defineModel<GetItemValue<T, string, NestedItem<T>> | undefined | string>();
</script>

<template>
  <USelect
    v-model="modelValue"
    class="core-select w-full outline-none rounded-lg border border-white/20 text-white bg-black/30 [box-shadow:none]"
    size="xl"
    :ui="{ item: 'text-white' }"
    v-bind="props as SelectProps"
  />
</template>
